/**
 * About 1054 — KUK home "About Us".
 * A click-to-play YouTube facade beside a ruled heading, justified copy and a
 * "Know More" outline button. No metadata rows.
 */

export const ABOUT_1054_CONSTANTS = {
  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "About Us",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "About Us",
      required: true,
      defaultValue: "About Us",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "highlight_border_color",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "The short accent bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "description",
      label: "Body copy",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Kurukshetra University, established in 1956…",
      defaultValue: "",
    },
    {
      fieldName: "description_text_color",
      label: "Body copy colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "video_link",
      label: "YouTube URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://www.youtube.com/watch?v=…",
      description:
        "Watch, youtu.be, /embed/ and /shorts/ links all work, as does a bare video id.",
      defaultValue: "",
    },
    {
      fieldName: "desktop_image",
      label: "Poster override",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — falls back to the video's own thumbnail",
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Poster alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Band background",
      value: "#F8F8F8",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F8F8F8",
    },
    {
      fieldName: "read_more_text",
      label: "CTA label",
      value: "Know More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Know More",
      defaultValue: "Know More",
    },
    {
      fieldName: "read_more_color",
      label: "CTA text and border colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "is_cta",
      label: "Is CTA (lead popup)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      defaultValue: false,
    },
    {
      fieldName: "cta_link",
      label: "CTA URL (used when Is CTA is off)",
      value: "/about",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/about",
      defaultValue: "/about",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
